import React, { ReactNode } from "react";
import cn from "classnames";

type Props = {
  className?: string;
  title?: string;
  text?: string;
  children?: ReactNode;
};

export const InvoiceSidebarWrapper: React.FC<Props> = (props) => {
  const { className, title, text, children } = props;
  return (
    <div className={cn("flex flex-col min-h-screen", className)}>
      {title && (
        <div className="font-poppins text-xl font-bold text-gray-500 mb-4">
          {title}
        </div>
      )}
      {text && (
        <div className="font-manrope text-basefont-semibold mb-10 text-gray-300">
          {text}
        </div>
      )}
      {children}
    </div>
  );
};
